import React, { useState } from "react";
import { Grid, Autocomplete, TextField, Box } from "@mui/material";
import CompanySelect from "../CommonComponents/CompanySelect";
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "../CommonComponents/RightDrawer";
import { formatDate, getIdNameIfAdmin, canAssignStaff } from "../../utils/commonutils";
import GlobalTimePicker from "../CommonComponents/Timeinput";
import { MasterAutocomplete } from "../CommonComponents/MasterSelect";
import {
  FALLBACK_FOLLOWUP_PRIORITY,
  FALLBACK_FOLLOWUP_STATUS,
} from "../../utils/masterFallbacks";

const FollowupModal = ({
  isOpen,
  mode,
  onClose,
  onSubmit,
  followupData,
  employeeData,
  customerData,
  props
}) => {
  const employeeObj = getIdNameIfAdmin(props?.authData);
  const [formData, setFormData] = useState({
    title: followupData?.title || "",
    date: formatDate(followupData?.date) || "",
    time: followupData?.time || "12:00 AM",
    customer: followupData?.customerId || null,
    employee: followupData?.employeeId || employeeObj || null,
    note: followupData?.note || "",
    priority: followupData?.priority || "",
    status: followupData?.status || "",
  });
  const [errors, setErrors] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (e, val, field) => {
    setFormData((prev) => ({ ...prev, [field]: val }));
  };

  const handleSubmit = () => {
    const requiredFields = [
      "title",
      "date",
      "time",
      "customer",
      "employee",
      "note",
      "priority",
      "status",
    ];
    const missing = requiredFields.filter((field) => !formData[field]);
    if (missing.length > 0) {
      setErrors(missing);
      return;
    }
    onSubmit(formData);
    onClose();
  };
  return (
    <Modal className="all-modals" isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose} kicker="Follow-up">
        {mode === "add" ? "Schedule follow-up" : "Edit follow-up"}
      </ModalHeader>
      <ModalBody>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <p className="small-text">Title</p>
            <input
              className="input-main"
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Follow-up Title"
            />
            {errors.includes("title") && (
              <p className="error-message">Title shouldn't be empty</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="small-text">Date</p>
            <input
              className="input-main"
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
            {errors.includes("date") && (
              <p className="error-message">Date shouldn't be empty</p>
            )}
          </Grid>

    <Grid item xs={12} sm={6}>
  <p className="small-text">Time</p>

  <GlobalTimePicker
    value={
      formData.time
        ? {
            hour: formData.time.split(" ")[0]?.split(":")[0] || "12",
            minute: formData.time.split(" ")[0]?.split(":")[1] || "00",
            ampm: formData.time.split(" ")[1] || "AM",
          }
        : { hour: "12", minute: "00", ampm: "AM" }
    }
    onChange={(val) => {
      setFormData((prev) => ({
        ...prev,
        time: val,
      }));
    }}
  />

  {errors.includes("time") && (
    <p className="error-message">Time shouldn't be empty</p>
  )}
</Grid>

          <Grid item xs={12} sm={6}>
            <p className="small-text">Select Company</p>
            <CompanySelect
              options={customerData}
              value={formData.customer}
              onChange={(val) => handleDropdownChange(null, val, "customer")}
              placeholder="Select company"
            />
            {errors.includes("customer") && (
              <p className="error-message">Customer shouldn't be empty</p>
            )}
          </Grid>

        <Grid item xs={12} sm={6}>
            <p className="small-text">Assign Employee</p>
            <Autocomplete
              name="employee"
              value={formData.employee || null}
              options={Array.isArray(employeeData) ? employeeData : []}
              disabled={!canAssignStaff(props?.authData?.role)}
              onChange={(e, val) => handleDropdownChange(e, val, "employee")}
              getOptionLabel={(option) => option?.name || ""}
              isOptionEqualToValue={(option, value) =>
                String(option?._id) === String(value?._id)
              }
              slotProps={{ popper: { sx: { zIndex: 20000 } } }}
              renderOption={(props, option) => (
                <Box component="li" {...props} key={option?._id || option?.name}>
                  {option?.name}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Assign employee"
                  size="small"
                />
              )}
            />
            {errors.includes("employee") && (
              <p className="error-message">Employee shouldn't be empty</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="small-text">Priority</p>
            <MasterAutocomplete
              group="followup_priority"
              fallback={FALLBACK_FOLLOWUP_PRIORITY}
              value={formData.priority}
              onChange={(e, val) => handleDropdownChange(e, val, "priority")}
              placeholder="Select priority"
            />
            {errors.includes("priority") && (
              <p className="error-message">Priority shouldn't be empty</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <p className="small-text">Status</p>
            <MasterAutocomplete
              group="followup_status"
              fallback={FALLBACK_FOLLOWUP_STATUS}
              value={formData.status}
              onChange={(e, val) => handleDropdownChange(e, val, "status")}
              placeholder="Select status"
            />
            {errors.includes("status") && (
              <p className="error-message">Status shouldn't be empty</p>
            )}
          </Grid>

          <Grid item xs={12} sm={8}>
            <p className="small-text">Note</p>
            <textarea
              className="input-main textarea"
              rows={2}
              name="note"
              value={formData.note}
              onChange={handleChange}
              placeholder="Note"
            />
            {errors.includes("note") && (
              <p className="error-message">Note shouldn't be empty</p>
            )}
          </Grid>
        </Grid>
      </ModalBody>

      <ModalFooter>
        <Button className="btn btn-border" onClick={onClose}>
          Cancel
        </Button>
        <Button className="btn btn-colored" onClick={handleSubmit}>
          {mode === "add" ? "Save follow-up" : "Save changes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default FollowupModal;
